import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";

export class LookupConfiguration{

  LookupReportId:NumberUDF;
  DefaultPropertyFilterLabel:StringUDF;
  UPCFilterLabel:StringUDF;
  FilterLabelStoreID : StringUDF;

  get(): any {
    return {
      LookupReportId:this.LookupReportId.value,
      DefaultPropertyFilterLabel: this.DefaultPropertyFilterLabel.value,
      UPCFilterLabel:this.UPCFilterLabel.value,
      FilterLabelStoreID:this.FilterLabelStoreID.value,
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/lookUp.config.ts